import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

// Simple confirm shown when the X is clicked on a data-entry dialog with
// unsaved input. Keeps normal close-on-outside behaviour itself.
export const DiscardConfirm = ({ open, onOpenChange, onDiscard }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-sm sm:max-w-sm" data-testid="discard-confirm-dialog">
      <DialogHeader>
        <DialogTitle className="text-lg font-bold uppercase tracking-tight">Discard this entry?</DialogTitle>
      </DialogHeader>
      <p className="text-sm text-gray-600 py-1">Your entered details will be lost.</p>
      <DialogFooter>
        <Button
          variant="outline"
          size="sm"
          className="rounded-sm"
          onClick={() => onOpenChange(false)}
          data-testid="discard-keep-btn"
        >Keep editing</Button>
        <Button
          size="sm"
          className="rounded-sm bg-red-600 text-white hover:bg-red-700"
          onClick={onDiscard}
          data-testid="discard-confirm-btn"
        >Discard</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
